import { SubmissionError } from 'redux-form';
import { BotDetectedError } from '../lib/errors';
import { setLocation } from '../lib/helpers';
import { setCookie } from './localStorageUtil';


export const reservationFormHandler = (response, props) => {
	const { error, payload } = response;
	if (props.botErrors) {
		props.setBotErrors(false);
	}

	if (error) {
		if (error instanceof BotDetectedError) {
			props.setBotErrors(true);
		}
		throw new SubmissionError({ _error: error.message });
	} else {
		/**
		 * When reservationFormHandler is called, it returns the props below
		 * to the composed decorators in the UnitReservationForm component.
		 * That component has a `componentWillReceiveProps` lifecycle method
		 * that checks to see if the trackedBooking prop has changed from false
		 * to a truthy value. If so, it calls the setLocation function there and
		 * redirects the page.
		 *
		 * However, sometimes either tracking fails or takes a very long time.
		 * This can cause the page to hang or not redirect at all. As a stopgap,
		 * we can set a timeout here to redirect the page after a certain amount
		 * of time has passed, and hope that the tracking has completed by then.
		 *
		 * Deleting this setLocation will cause reservations to not redirect to
		 * the confirmation for users who block tracking.
		 */

		if (payload?.bookingAuth) {
			setCookie('jwt', payload.bookingAuth);
		}


		// redirect is booking payload has bookingAuth
		const redirectionConfirmationCode = payload?.bookingAuth
		? `/reservation/confirmation/${payload.confirmationCode}?email=${payload.email}`
  		: `/reservation/confirmation/${payload.confirmationCode}`;

		setLocation(
		 	redirectionConfirmationCode,
		 	1000
		);

		return {
			payload
		};
	}
};
